<template>
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div class="btn active">申报评估考核阶段</div>
        <div class="btn" @click="toPath">历史文件库</div>
      </div>
    </template>
    <template v-slot:nav_right>
      <!-- <div v-if="!empty" class="yioks_btn" @click="handleSaveTemp">
        临时保存
      </div> -->
      <div v-if="!empty" class="yioks_btn" @click="handleAll">全部完成并提交</div>
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <template v-if="!empty && !loading">
              <div class="nav-btn left-btn" v-if="isShowQueryBtn">
                <el-button
                  type=""
                  size="small"
                  icon="el-icon-arrow-left"
                  @click="handleLeft"
                ></el-button>
              </div>
              <div class="" :class="isShowQueryBtn ? 'tag-box' : 'tag-box1'">
                <vue-scroll :ops="opsHorizontal" ref="scrollDom">
                  <div class="scroll-wrapper" ref="scrollWrapper">
                    <el-button type="primary" size="small" @click="toUploadHome"
                      >首页</el-button
                    >
                    <el-button
                      :type="''"
                      size="small"
                      v-for="(item, index) in queryList"
                      :key="index"
                      @click="changeCurrentQuery(item)"
                      >{{ item }}</el-button
                    >
                  </div>
                </vue-scroll>
              </div>
              <div class="nav-btn right-btn" v-if="isShowQueryBtn">
                <el-button
                  type=""
                  size="small"
                  icon="el-icon-arrow-right"
                  @click="handleRight"
                ></el-button>
              </div>
            </template>
          </div>
          <div class="list_wrap" v-if="!empty && !loading">
            <div class="tongji-wrapper">
              <vue-scroll>
                <div class="tongji-content">
                  <!-- 总进度 -->
                  <div class="tongji-item">
                    <fieldset>
                      <legend class="first-title">总完成进度</legend>
                      <span
                        class="tongji"
                        v-if="stageApplyType"
                        :data-stage-type="stageApplyType"
                        >类型：{{ stageApplyType }}</span
                      >
                      <span class="item-text"> 已完成： {{ tongjiAll }}% </span>
                    </fieldset>
                  </div>
                  <div
                    class="tongji-item"
                    v-for="(item, tjIndex) in Object.values(tongji)"
                    :key="tjIndex"
                  >
                    <fieldset>
                      <legend>{{ item.targetName }}</legend>
                      <span class="item-text"> 已提交项：{{ item.ok }}项 </span>
                      <span class="item-text">
                        未提交项：{{ item.total }}项
                      </span>
                      <span class="item-text"
                        >完成度：{{
                          ((item.ok / item.total) * 100).toFixed(0)
                        }}%</span
                      >
                    </fieldset>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>

          <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
          <yioks-loading v-if="loading"></yioks-loading>
          <template v-if="isShowLevelDialog">
            <el-dialog
              title="类型"
              :close-on-press-escape="false"
              :close-on-click-modal="false"
              :show-close="false"
              :visible.sync="isShowLevelDialog"
              custom-class="level-form-dialog"
              width="620px"
            >
              <el-form
                :model="levelForm"
                ref="levelFormDom"
                :rules="levelFormRules"
                class="level-form"
                :label-width="'70px'"
              >
                <el-form-item label="类型" prop="stageApplyType">
                  <el-select
                    v-model="levelForm.stageApplyType"
                    class="w_100"
                    placeholder="请选择类型"
                  >
                  <!-- select_levels -->
                    <el-option
                      v-for="item in stageTypeListForSelection"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <div class="tips">
<!--                    <p>1：请申报单位根据自身情况和上海市{{isInClubSystem ? '星级足球培训机构' : '精英培训基地'}}关键指标要求选择合适的基地类型如实申报。</p>-->
                    <p>1：申报单位承诺提交的全部信息和证明材料均真实、准确、有效，没有隐瞒或虚构任何事实，也没有买卖或造假等不诚信行为。</p>
                    <p>2：如违反以上承诺，申报单位将承担由此产生的一切后果，愿意接受上海足协相应的处罚。</p>
                  </div>
                </el-form-item>
              </el-form>
              <div slot="footer" class="footer-btns">
                <el-button type="primary" @click="handleConfirmLevelForm"
                  >确 定</el-button
                >
                <!-- <el-button @click="isShowLevelDialog = false">取 消</el-button> -->
              </div>
            </el-dialog>
          </template>

          <template v-if="isUploadAll">
            <yioks-tip
              :showTip="isUploadAll"
              :tipMsg="
                isAllSubmited
                  ? '请确定是否完成并提交？提交后仍可撤回修改'
                  : '存在未提交的项目，请确定是否继续提交？提交后仍可撤回修改'
              "
              @callback="handleUploadCallBackAll"
            ></yioks-tip>
          </template>
          <template v-if="isShowSaveTemp">
            <yioks-tip
              :showTip="isShowSaveTemp"
              tipMsg="确定临时保存当前数据，后续仍可继续完善"
              @callback="handleConfirmSaveTemp"
            ></yioks-tip>
          </template>
        </div>
        <!-- <yioks-pagination :total="total" :page.sync="page"></yioks-pagination> -->
      </div>
    </template>
  </yioks-content>
</template>

<script>
import {
  getTargetListForSubmit,
  postTargetSumitAll,
  postStageType,
  getStageType,
} from "@/api/performance";
import { opsHorizontal } from "@/utils/scrollIndialog";
import storage from "@/utils/storage";
import { ops } from "@/utils/scrollIndialog";
import { requiredItem } from "@/assets/js/formRules";
import { stageTypeList } from '@/assets/js/yioksSelect';
import mixinAppConfig from '@/mixin/mixinAppConfig';

export default {
  mixins: [ mixinAppConfig ],
  components: {
    "upload-dialog": () => import("./components/uploadTarget"),
  },

  data() {
    return {
      ops,
      opsHorizontal: opsHorizontal(),
      pageList: [],
      queryList: [],
      currentQuery: "",
      empty: false,
      loading: false,
      // page: 0,
      // pageSize: 50, // 本页面暂时不做分页,尽量一页显示完成
      // total: 0,
      filterData: {
        targetName: "",
      },
      isUpload: false,
      editRow: {},
      isEditMode: false,
      isUploadAll: false,
      editRowAll: {},
      isEditModeAll: false,
      isShowSaveTemp: false,
      isShowQueryBtn: true,

      isShowLevelDialog: false,
      levelForm: {
        stageApplyType: "机构",
      },
      levelFormRules: {
        stageApplyType: [requiredItem("类型")],
      },
      // select_levels: stageTypeList,  // 使用 mixin/mixinAppConfig: stageTypeListForSelection
      stageApplyType: "",
    };
  },

  // watch: {
  //   page(val) {
  //     console.log("in watch change page:", val);
  //     this.page = val;
  //     this.changeQuery();
  //   },
  // },
  computed: {
    tongji() {
      let tongji = {};
      for (let i in this.pageList) {
        let item = this.pageList[i];
        if (!tongji[item.targetName]) {
          tongji[item.targetName] = {
            targetName: item.targetName,
            ok: 0,
            total: 0,
          };
        }
        tongji[item.targetName].total++;
        if (item.submit) {
          tongji[item.targetName].ok++;
        }
      }
      return tongji;
    },
    tongjiAll() {
      const all = this.pageList.length;
      const pass = this.pageList.filter((i) => i.submit).length;
      return ((pass / all) * 100).toFixed(0);
    },
    showPageList() {
      return this.pageList.filter((i) => i.targetName === this.currentQuery);
    },
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid;
    },

    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid;
    },

    stageName() {
      const { stageName } = this.$route.query;
      return stageName;
    },

    isAllSubmited() {
      if (this.pageList && this.pageList.length) {
        // let status = this.pageList.some((item) => {
        //   if (!item.submit) return item.submit;
        // });
        let status = true;
        this.pageList.forEach((item) => {
          if (!item.submit) {
            status = false;
          }
        });
        return status;
      } else {
        return false;
      }
    },

    totalScore() {
      if (this.pageList.length) {
        let allScore = 0;
        this.pageList.forEach((item) => {
          const { score } = item;
          if (score !== undefined && typeof score === "number") {
            allScore += score;
          }
        });
        return allScore;
      } else {
        return 0;
      }
    },
    stageType() {
      const { stageType } = this.$route.query;
      if(stageType) {
        return Number(stageType)
      } else {
        return 1
      }
    },
  },

  filters: {
    empty(val) {
      if (val !== undefined) {
        return val;
      } else {
        return "--";
      }
    },
  },

  created() {
    this.loadStageType();
    this.setQueryData();
    this.changeQuery(true);
  },

  mounted() {
    if (!!!this.stageType) {
      this.isShowLevelDialog = true;
    }
  },

  methods: {
    handleBack() {
      this.$router.push({
        path: "/home/index",
      });
    },
    handleAll() {
      this.isUploadAll = true;
    },
    handleSaveTemp() {
      this.isShowSaveTemp = true;
    },
    handleConfirmSaveTemp(flag) {
      if (flag) {
        this.$message.success("数据已临时保存！");
        // this.changeQuery(true); //  模拟保存，重新请求数据
        this.$router.go(-1);
      }
      this.isShowSaveTemp = false;
    },

    changeQuery(flag) {
      // flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.filterData,
          // page: this.page,
        },
      });
      this.loadPageList();
    },

    setQueryData() {
      const { groupUuid, stageUuid, targetName } = this.$route.query;
      // String(page) && (this.page = page);
      targetName && this.$set(this.filterData, "targetName", targetName);
    },

    loadPageList() {
      const { groupUuid, stageUuid, targetName } = this.$route.query;
      const paramsData = {
        groupUuid,
        stageUuid,
        // page,
        // targetSecondlyName: targetName,
        // size: this.pageSize,
      };
      this.loading = true;
      getTargetListForSubmit(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            this.empty = true;
            return;
          }
          const { targetSubmitListVos, orgAuditStageLog} = res;

          if (targetSubmitListVos.length) {
            this.pageList = targetSubmitListVos;
            for (let i in this.pageList) {
              let item = this.pageList[i];
              if (this.queryList.indexOf(item.targetName) === -1) {
                this.queryList.push(item.targetName);
              }
            }
            if(!this.currentQuery) this.currentQuery = this.queryList[0];
            // 设置搜索栏
            this.setQuerySelect();
            this.empty = false;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.empty = true;
          console.error("err", err);
        });
    },

    loadSourceData() {
      const { groupUuid, stageUuid, targetName } = this.$route.query;
      const paramsData = {
        groupUuid,
        stageUuid,
        // page,
        targetSecondlyName: targetName,
        // size: this.pageSize,
      };
      getTargetListForSubmit(paramsData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            this.empty = true;
            return;
          }
          const { targetSubmitListVos, orgAuditStageLog} = res;
          this.pageList = targetSubmitListVos;
        })
        .catch((err) => {
          this.empty = true;
          console.error("err", err);
        });
    },

    // 提交资料
    handleCheckTarget(row) {
      this.editRow = row;
      this.isEditMode = false;
      this.isUpload = true;
    },

    // 编辑考核
    handleEditRow(row) {
      this.editRow = row;
      this.isEditMode = true;
      this.isUpload = true;
    },

    // 提交弹窗回掉方法
    handleUploadCallBack(dialogStatus, confirmStatus) {
      this.isUpload = dialogStatus;
      if (confirmStatus) {
        if (!dialogStatus) {
          // this.changeQuery(true);
          this.editRow = {};
          this.isEditMode = false;
        } else {
          console.warn("call back error, dialog will be stay!");
        }
      } else {
        this.editRow = {};
      }
      this.loadSourceData();
    },

    // 保存全部
    handleUploadCallBackAll(confirmStatus) {
      if (confirmStatus) {
        const postData = {
          groupUuid: this.groupUuid,
          stageName: this.stageName,
          stageUuid: this.stageUuid,
          totalProgress: this.tongjiAll,  //
          auditScore: this.totalScore,
          stageApplyType: this.stageApplyType
        };
        postTargetSumitAll(postData)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.isUploadAll = false;
            this.$message.success("资料已提交！");
            this.$router.push({
              path: 'uploadStatus',
              query: {
                groupUuid: this.groupUuid,
                stageUuid: this.stageUuid,
                stageName: this.stageName,
              }
            })
          })
          .catch((err) => {
            console.error("err", err);
          });
      } else {
        this.isUploadAll = false;
      }
    },

    handleLeft() {
      this.$refs["scrollDom"].scrollBy({
        dx: -40,
      });
    },

    handleRight() {
      this.$refs["scrollDom"].scrollBy({
        dx: 40,
      });
    },

    setQuerySelect() {
      this.$nextTick(() => {
        const dom = this.$refs["scrollWrapper"];
        if (dom.offsetWidth > 700) {
          this.isShowQueryBtn = true;
        } else {
          this.isShowQueryBtn = false;
        }
      });
    },

    // 跳转
    toPath() {
      this.$router.push({
        path: "phaselist",
        query: {
          activeCom: "document-library",
        },
      });
    },

    // 去申报评估考核阶段首页
    toUploadHome() {
      this.$router.push({
        path: "uploadHome",
        query: {
          groupUuid: this.groupUuid,
          stageUuid: this.stageUuid,
          stageName: this.stageName,
          currentQuery: this.currentQuery,
        },
      });
    },

    changeCurrentQuery(val) {
      this.currentQuery = val;
      this.$router.push({
        path: "upload",
        query: {
          groupUuid: this.groupUuid,
          stageUuid: this.stageUuid,
          stageName: this.stageName,
          currentQuery: val,
        },
      });
    },

    handleConfirmLevelForm() {
      this.$refs["levelFormDom"].validate((valid) => {
        if (valid) {
          const postData = {
            stageApplyType: this.levelForm.stageApplyType,
            stageUuid: this.stageUuid,
          };
          postStageType(postData)
            .then((res) => {
              this.isShowLevelDialog = false;
              this.loadStageType();
            })
            .catch((err) => {
              console.error("err", err);
            });
        }
      });
    },

    // 仅获取申报类型
    loadStageType() {
      getStageType({})
        .then((res) => {
          this.stageApplyType = res.stageApplyType || "--"; // 精英型；提高型；发展型
          const { stageType } = this.$route.query;
          if (stageType == "0") {
            this.$router.replace({
              path: this.$route.path,
              query: {
                ...this.$route.query,
                stageType: 1, // ?
              },
            });
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    handleAll() {
      this.isUploadAll = true;
    },
    handleSaveTemp() {
      this.isShowSaveTemp = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
  .select_wrap
    padding 20px 40px 20px
    min-height 40px
    display flex
    justify-content space-between
    width 100%
    .nav-btn
      width 50px
      display flex
      align-items center
      justify-content center
      cursor pointer
    .tag-box
      // flex 1
      width 680px
      margin 0 auto
      .scroll-wrapper
        display flex
        align-items center
        justify-content flex-start
        position absolute
    .tag-box1
      flex 1
      height 40px
.list_wrap
  flex 1
  overflow hidden
  .tongji-wrapper
    height 500px
    .tongji-content
      margin 0 40px
      display flex
      flex-direction column
      .tongji-item
        margin-bottom 10px
        padding 10px
        user-select none
        .item-text
          font-size 18px
          min-width 120px
          &.item-text
            margin-left 15px
.footer-btns
  display flex
  justify-content center
  align-items center
.level-form-dialog
  /deep/.el-dialog__body
    padding 20px 20px 10px
.level-form
  padding-right 33px
  .tips
    color #FF0000
    font-size 14px
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
.w_100
  width 100%
.first-title
  font-size 1.4em
  color $red_color
</style>
